// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2OkbU","tab":"Tabs_tab__1S3JN","tabActive":"Tabs_tabActive__2iKOB"};